import { Icon, Link, Text, View } from "@/components";

const Categories = ({ cards }: { cards: [] }) => (
  <View className="flex justify-start gap-4 xxxl:gap-6 mb-4 xxxl:mb-6 pb-12 overflow-x-scroll scrollbar-h-custom">
    {cards.map(({ id, label, icon, url, status }) =>
      status === 0 ? (
        <View
          key={id}
          className="min-w-[195px] w-full p-4 border-[3px] flex flex-col items-center rounded-2xl border-n0 dark:border-n500 bg-primary/10 cursor-not-allowed"
        >
          <View className="rounded-2xl bg-n0 dark:bg-bg3 p-3 text-primary mb-5">
            <Icon name={icon} size="3x" />
          </View>
          <Text className="text-base md:text-lg lg:text-xl font-medium">
            {label}
          </Text>
        </View>
      ) : (
        <Link
          href={url}
          key={id}
          className="min-w-[195px] w-full p-4 border-[3px] flex flex-col items-center rounded-2xl border-n0 dark:border-n500 bg-primary/10"
        >
          <View className="rounded-2xl bg-n0 dark:bg-bg3 p-3 text-primary mb-5">
            <Icon name={icon} size="3x" />
          </View>
          <Text className="text-base md:text-lg lg:text-xl font-medium">
            {label}
          </Text>
        </Link>
      )
    )}
  </View>
);

export default Categories;
